import React from 'react';
import FadeInAnimationWrapper from 'src/elements/animation/fade-in/FadeInAnimationWrapper';
import PhoneVideo from 'src/elements/video/phone.video';
import BannerTextBlock from 'src/molecules/banner/text.block';
import {
  BannerContainer,
  BannerContainerProps
} from 'src/organisms/banners/Banner.landing.styles';
import BannerLandingConfetti from './banner.landing.confetti'

export interface BannerLandingProps extends BannerContainerProps {
  title: string;
  description: string;
  removeRating?: boolean;
  actionLink: {
    url: string;
    text: string;
    caption?: string;
  }
  actionButton: {
    text: string;
    onClick: () => void;
  }
  videoUrl?: string;
}

const BannerLanding = (props: BannerLandingProps): JSX.Element => {

  return (
    <FadeInAnimationWrapper transitionTimeSeconds={0.75} style={{ display: 'grid', justifySelf: 'center' }}>
      <BannerContainer textPosition={props.textPosition}>
        <BannerLandingConfetti />
        <BannerTextBlock
          title={props.title}
          description={props.description}
          removeRating={props.removeRating}
          actionLink={props.actionLink}
          actionButton={props.actionButton}
        />
        
        <PhoneVideo videoUrl={props.videoUrl} />
      </BannerContainer>
    </FadeInAnimationWrapper>
  )
}

export default BannerLanding;
